module.exports = __webpack_public_path__ + "static/media/paypal-logo.48de1322.png";